import { createContext } from 'react';
import { AlertColor } from '@mui/material';

export type AppToasterContextType = {
    appToasterContent: AppToasterContent;
    setAppToasterContent: (v: AppToasterContent) => void;
};

export const AppToasterContext = createContext<AppToasterContextType>({
    appToasterContent: { isOpen: false, severity: 'error' },
    setAppToasterContent: () => undefined,
});

export type AppToasterContent = {
    isOpen: boolean;
    severity: AlertColor;
    message?: string;
};
